var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeleSearchDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.583 17.333c0-.596.488-1.084 1.084-1.084.595 0 1.083.488 1.083 1.084 0 .596-.488 1.083-1.083 1.083a1.087 1.087 0 0 1-1.084-1.083zM13 16.249h4.333c.596 0 1.084.488 1.084 1.084 0 .596-.488 1.083-1.084 1.083H13a1.087 1.087 0 0 1-1.083-1.083c0-.596.487-1.084 1.083-1.084zm6.5 5.417h-13a1.085 1.085 0 0 1-1.083-1.083v-6.5h15.166v6.5c0 .597-.486 1.083-1.083 1.083zM6.5 6.499h1.083v1.084c0 .596.488 1.083 1.084 1.083.595 0 1.083-.487 1.083-1.083V6.499h6.5v1.084c0 .596.488 1.083 1.083 1.083.596 0 1.084-.487 1.084-1.083V6.499H19.5c.597 0 1.083.487 1.083 1.084v4.333H5.417V7.583c0-.597.486-1.084 1.083-1.084zm13-2.166h-1.083V3.249c0-.595-.488-1.083-1.084-1.083-.595 0-1.083.488-1.083 1.083v1.084h-6.5V3.249c0-.595-.488-1.083-1.083-1.083-.596 0-1.084.488-1.084 1.083v1.084H6.5a3.254 3.254 0 0 0-3.25 3.25v13a3.254 3.254 0 0 0 3.25 3.25h13a3.254 3.254 0 0 0 3.25-3.25v-13a3.254 3.254 0 0 0-3.25-3.25z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bt8pqwjg6a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 20,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.583 17.333c0-.596.488-1.084 1.084-1.084.595 0 1.083.488 1.083 1.084 0 .596-.488 1.083-1.083 1.083a1.087 1.087 0 0 1-1.084-1.083zM13 16.249h4.333c.596 0 1.084.488 1.084 1.084 0 .596-.488 1.083-1.084 1.083H13a1.087 1.087 0 0 1-1.083-1.083c0-.596.487-1.084 1.083-1.084zm6.5 5.417h-13a1.085 1.085 0 0 1-1.083-1.083v-6.5h15.166v6.5c0 .597-.486 1.083-1.083 1.083zM6.5 6.499h1.083v1.084c0 .596.488 1.083 1.084 1.083.595 0 1.083-.487 1.083-1.083V6.499h6.5v1.084c0 .596.488 1.083 1.083 1.083.596 0 1.084-.487 1.084-1.083V6.499H19.5c.597 0 1.083.487 1.083 1.084v4.333H5.417V7.583c0-.597.486-1.084 1.083-1.084zm13-2.166h-1.083V3.249c0-.595-.488-1.083-1.084-1.083-.595 0-1.083.488-1.083 1.083v1.084h-6.5V3.249c0-.595-.488-1.083-1.083-1.083-.596 0-1.084.488-1.084 1.083v1.084H6.5a3.254 3.254 0 0 0-3.25 3.25v13a3.254 3.254 0 0 0 3.25 3.25h13a3.254 3.254 0 0 0 3.25-3.25v-13a3.254 3.254 0 0 0-3.25-3.25z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bt8pqwjg6a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M-41.164-41.166H67.169V67.167H-41.164z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleSearchDate);
export default __webpack_public_path__ + "static/media/tele_search_date.3bfb6c60.svg";
export { ForwardRef as ReactComponent };